module.exports = __webpack_public_path__ + "img/logo-loading.d9a7bea5.svg";